import { useCallback, useState } from 'react';
import { validateField } from '../../lib/shared/validate-field';
import { requestToMagicLink } from '../../lib/use-cases/request-to-magic-link';
import { validateEmail } from '../../lib/models/email';

function useAuthForm() {
    const [isPending, setIsPending] = useState(false);
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [fields, setFields] = useState({email: ''});
    const [errors, setErrors] = useState({email: '', form: ''});

    const changeField = useCallback((name, value) => {
        if (errors[name] || errors.form) {
            setErrors(prevState => ({...prevState, [name]: '', form: ''}));
        }

        setFields(prevState => ({...prevState, [name]: value}));
    }, [errors]);

    const submitForm = async (e) => {
        e.preventDefault();

        try {
            setIsPending(true);

            const validationData = await validateField(fields.email, [validateEmail]);

            if (!validationData.isValid) {
                return setErrors(prevState => ({...prevState, email: validationData.message}));
            }

            const response = await requestToMagicLink({email: fields.email});

            if (response.email && response.ttl) {
                setIsSuccessful(true);
            } else {
                setErrors(prevState => ({...prevState, form: 'Repeat please request'}));
            }
        } catch (error) {
            setErrors(prevState => ({...prevState, form: error?.message || 'Fail'}));
        } finally {
            setIsPending(false);
        }
    };

    return {
        fields,
        errors,
        isPending,
        isSuccessful,
        submitForm,
        changeField
    }
};

export {
    useAuthForm
};